import { render, staticRenderFns } from "./WazeSlot.vue?vue&type=template&id=ddc8e044&scoped=true"
import script from "./WazeSlot.vue?vue&type=script&lang=js"
export * from "./WazeSlot.vue?vue&type=script&lang=js"
import style0 from "./WazeSlot.vue?vue&type=style&index=0&id=ddc8e044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc8e044",
  null
  
)

export default component.exports